import type { Widen } from '../catalogue';
import type { svMedia } from '../sv/media';

export const enMedia: Widen<typeof svMedia> = {
  shared: {
    searchPlaceholder: 'Search…',
    noStatus: 'No status',
    noProject: 'No project'
  },
  filtersSideMenu: {
    clearAll: 'Clear all filters',
    clearAllTitle: 'Remove all active filters and show every report',
    showingRead: 'Showing read',
    showingUnread: 'Showing unread',
    showingImage: 'Showing image',
    showingVideo: 'Showing video',
    showingAssignee: 'Showing assignee: {{name}}',
    showingNoAssignee: 'Showing items with no assignee',
    showingSearch: 'Showing searchterm: {{term}}',
    showingStatus: 'Showing status: {{status}}',
    showingNoStatus: 'Showing items with no status',
    showingProject: 'Showing items with the project: {{project}}',
    showingNoProject: 'Showing items with no projects',
    showingProjectsByStatus: 'Showing projects with the status: {{status}}',
    viewAs: 'View data as files or projects',
    files: 'Files',
    filesTitle: 'List reports individually',
    projects: 'Projects',
    projectsTitle: 'Group reports by project',
    filterProjectsByStatus: 'Filter <strong>projects</strong> by status',
    chooseStatus: 'Choose status',
    searchComments: 'Search comments',
    clearSearchTitle: 'Clear search text',
    search: 'Search',
    searchTitle: 'Filter reports whose comments contain this text',
    filterByDate: 'Filter by date created',
    after: 'After',
    before: 'Before',
    datePlaceholder: 'YYYY-MM-DD',
    filterByAssignee: 'Filter by assignee',
    assigneeTitle: 'Show only reports assigned to a specific person',
    noAssignee: 'No assignee',
    chooseAssignee: 'Choose assignee',
    noAssigneeTitle: 'Show only reports nobody has been assigned to',
    filterNoAssignee: 'Filter on items with no assignee',
    filterByStatus: 'Filter by status',
    statusTitle: 'Show only reports with a specific status',
    noStatusTitle: 'Show only reports with no status set',
    filterNoStatus: 'Filter on items with no status',
    filterByProject: 'Filter by projects',
    projectTitle: 'Show only reports belonging to a specific project',
    chooseProject: 'Choose project',
    noProjectTitle: 'Show only reports not linked to a project',
    filterNoProject: 'Filter on items with no project',
    filterByRead: 'Filter by read or unread',
    readTitle: 'Show only reports that have been read',
    read: 'Read',
    unreadTitle: 'Show only reports that have not been read',
    unread: 'Unread',
    filterByFileType: 'Filter by image or video',
    imageTitle: 'Show only photo reports',
    image: 'Image',
    videoTitle: 'Show only video reports',
    video: 'Video'
  },
  mediaViewer: {
    loading: 'Loading…',
    notFound: 'Media not found',
    errorAlt: 'error',
    drawingPin: 'Drawing: {{name}}, page {{page}}',
    somethingWentWrong: 'Something went wrong. Please try again later.',
    somethingWentWrongWithError: 'Something went wrong. Please try again later. Error: {{error}}',
    imageAlt: 'The photo of the media item',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    resetZoom: 'Reset zoom',
    download: 'Download',
    downloadFailed: 'Could not download the file.',
    previous: 'Previous',
    next: 'Next',
    position: '{{index}} of {{count}}',
    panel: 'Report',
    status: 'Status',
    project: 'Project',
    assignee: 'Assignee',
    noComment: 'No internal comment'
  },
  statusSelector: {
    changed: 'Status changed on file',
    changeFailed: 'Failed changing status on file',
    unassigned: 'Status detached from the media item',
    unassignFailed: 'Could not detach the status from the media item.',
    unassign: 'Detach status'
  },
  projectSelector: {
    added: 'Project added to the file',
    addFailed: 'Failed adding project to file',
    unassigned: 'Project detached from the media item',
    unassignFailed: 'Could not detach the project from the media item.',
    unassign: 'Detach project'
  },
  assigneeSelector: {
    noAssignee: 'No Assignee',
    assigned: 'User assigned to the file',
    assignFailed: 'Failed assigning the user to the file',
    unassigned: 'Unassigned user from the file',
    unassignFailed: 'Could not detach the assignee from the media item.',
    unassign: 'Detach assignee'
  },
  positionPicker: {
    loadFailed: 'Could not load the map.'
  }
};
